"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  log: function log() {},
  debug: function debug() {},
  error: function error() {}
};


//////////////////
// WEBPACK FOOTER
// ./~/auth0-tag-manager/lib/logger.js
// module id = 88
// module chunks = 0